import Vue from 'vue'
import { SYSTEM } from '@/config'
import store from '@/store'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.axios.defaults.params = { program_type: 'industry', system: SYSTEM }

axios.interceptors.request.use((request) => {
  if (!request.url.match(/user$/)) store.commit('setProgress', true);
  return request;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  const build = response.headers['x-build']
  if (build && !localStorage.getItem('build_' + SYSTEM)) localStorage.setItem('build_' + SYSTEM, build);
  if (build && +build > +localStorage.getItem('build_' + SYSTEM)) {
    localStorage.setItem('build_' + SYSTEM, build);
    location.reload(true);
  }
  return response;
}, (error) => {
  return Promise.reject(error);
});